
const CareCommentTitleType = Symbol();

export class CareCommentTitle {
    [CareCommentTitleType]: any;
    readonly value: string;

    private constructor(careCommentTitle: string) {
        this.value = careCommentTitle;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 100;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上100文字以下で入力してください。`;
    }

    static fromString(careCommentTitle: string): CareCommentTitle {
        return new CareCommentTitle(careCommentTitle);
    }

    format(maxLength?: number): string {
        return (maxLength && this.value.length > maxLength) ? this.value.substring(0, maxLength).concat("...") : this.value;
    }
}
